import { render, staticRenderFns } from "./gashistoryedata.vue?vue&type=template&id=4b71753a&scoped=true&"
import script from "./gashistoryedata.vue?vue&type=script&lang=ts&"
export * from "./gashistoryedata.vue?vue&type=script&lang=ts&"
import style0 from "./gashistoryedata.vue?vue&type=style&index=0&id=4b71753a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71753a",
  null
  
)

export default component.exports